import download from "downloadjs";
import React, { useState } from "react";
import { NotificationManager } from "react-notifications";
import "./Events.css";
import PageTitle from "../../../components/PageTitle/PageTitle";
import ListEvents from "../ListEvents/ListEvents";
import { useListManager } from "../../../contexts/list.manager";
import EventDetails from "../EventDetails/EventDetails";
import FiltersEvents from "../FiltersEvents/FiltersEvents";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import { ScrollText } from "lucide-react";
import Container from "../../../components/Container/Container";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import { useTranslation } from "react-i18next";
import { useUserStore } from "../../../contexts/userStore";
import EventsService from "../../../services/EventsService";
import { formatBytes } from "../../../utils/bytes";

const Events = () => {
  const { lineSelected, isCard } = useListManager();
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    search: "",
    name: "",
    eventType: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    continuousInterval: "",
    licence: "",
    detail: "",
    data: "",
    user: "",
    uuid: "",
    result: "",
    info: "",
    carName: "",
    carBrand: "",
    carColor: "",
    carPlate: "",
  });
  const { t } = useTranslation();
  const { selectedCondominio } = useUserStore();
  const [isExporting, setIsExporting] = useState(false);
  const [exportedBytes, setExportedBytes] = useState(0);

  const downloadCsv = async () => {
    if (!selectedCondominio) {
      NotificationManager.error("", "Selecione uma unidade antes de exportar os eventos", 5000);
      return;
    }

    const filename = `${new Date().toISOString().slice(0, 10)}-events.csv`;
    let fileHandle;

    if (window.showSaveFilePicker) {
      try {
        fileHandle = await window.showSaveFilePicker({
          suggestedName: filename,
          types: [{
            description: "CSV",
            accept: { "text/csv": [".csv"] },
          }],
        });
      } catch (error) {
        if (error.name === "AbortError") {
          return;
        }
        NotificationManager.error("", "Não foi possível iniciar o download do CSV", 5000);
        return;
      }
    }

    setIsExporting(true);
    setExportedBytes(0);
    let fileWriter;
    const chunks = [];

    try {
      const response = await EventsService.downloadCsv(selectedCondominio, filters);
      if (!response?.body) {
        throw new Error("A resposta de exportação não contém um stream");
      }

      fileWriter = fileHandle ? await fileHandle.createWritable() : null;
      const bom = new TextEncoder().encode("\uFEFF");
      if (fileWriter) {
        await fileWriter.write(bom);
      } else {
        chunks.push(bom);
      }

      const reader = response.body.getReader();
      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          break;
        }

        setExportedBytes((bytes) => bytes + value.byteLength);
        if (fileWriter) {
          await fileWriter.write(value);
        } else {
          chunks.push(value);
        }
      }

      if (fileWriter) {
        await fileWriter.close();
      } else {
        download(
          new Blob(chunks, { type: "text/csv;charset=utf-8;" }),
          filename,
          "text/csv;charset=utf-8;",
        );
      }
    } catch (error) {
      if (fileWriter) {
        try {
          await fileWriter.abort();
        } catch (abortError) {
          console.error("Erro ao cancelar a gravação do CSV", abortError);
        }
      }
      console.error("Erro ao exportar eventos para CSV", error);
      NotificationManager.error("", "Erro ao exportar eventos para CSV", 5000);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="consulta-container">
      <div className="search-list-wrapper">
        <SearchContainer
          icon={<ScrollText size={18} />}
          title={t("common.reports")}
          className="mb-0!"
          containerClassName="pb-0!"
          hideAddButton={true} />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ width: "100%" }}>
            <FiltersEvents
              filtersApplied={(filters) => {
                setFilters(filters);
                setCurrentPage(1);
              }}
              onDownloadCsv={downloadCsv}
              isExporting={isExporting}
              exportedBytesLabel={formatBytes(exportedBytes)}
            />
          </div>
          <Container>
            <ListEvents filters={filters} currentPage={currentPage} setCurrentPage={setCurrentPage} />
          </Container>
        </div>
      </div>
    </div>
  );
};

export default Events;
